import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector, shallowEqual } from 'react-redux';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';

export const useDDSavingsAmount = () => {
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const { configPriceCapDdSavings } = useFlags();

  let savingsAmount = '';
  if (fuelType.electric && fuelType.gas) {
    savingsAmount = configPriceCapDdSavings.AMOUNT.DUAL;
  } else if (fuelType.electric) {
    savingsAmount = configPriceCapDdSavings.AMOUNT.ELECTRIC;
  } else if (fuelType.gas) {
    savingsAmount = configPriceCapDdSavings.AMOUNT.GAS;
  }

  return {
    savingsAmount,
    heatPumpAmount: configPriceCapDdSavings.HEAT_PUMP_AMOUNT,
    priceCapDate: configPriceCapDdSavings.DATE
  };
};
